module.exports = __webpack_public_path__ + "img/222-Veka Spectral 7040-Gris Fenêtre.png";